const { dataTypeMapping, actionElementActionsByNsRel, blockConversions } = require('./config');
const get = require('lodash/get');
module.exports = {
    getJavaScriptTypeForHNodeType,
    getDefaultValueForHNode,
    shouldShowTimeInput,
    getActionsAllowed,
    convertDeprecatedBlockTypes
};

// Ideally, there would be a conversion script to do this all at once.  This will save the
// development time for that.
function convertDeprecatedBlockTypes(hNode) {
    const newType = get(blockConversions, [hNode.hNodeTypeGroup, hNode.hNodeType]);
    if (newType) {
        hNode.hNodeType = newType.hNodeType ?? hNode.hNodeType;
        hNode.hNodeTypeGroup = newType.hNodeTypeGroup ?? hNode.hNodeTypeGroup;
    }
}

function getJavaScriptTypeForHNodeType(hNode) {
    let outputType;
    let hNodeType = hNode.hNodeType;
    if (hNode.dataType) {
        if (hNode.pattern) {
            return `${hNode.dataType} (${hNode.pattern})`;
        }
        return hNode.dataType;
    }
    Object.keys(dataTypeMapping).forEach(key => {
        if (dataTypeMapping[key].hNodeTypes && dataTypeMapping[key].hNodeTypes.includes(hNodeType)) {
            outputType = dataTypeMapping[key].JavaScript;
            return;
        } else if (dataTypeMapping[key].formats) {
            Object.values(dataTypeMapping[key].formats).forEach(f => {
                if (f.hNodeTypes.includes(hNodeType)) {
                    outputType = dataTypeMapping[key].JavaScript;
                    return;
                }
            });
        }
    });
    if (hNodeType === 'InvisibleElement') {
        outputType = dataTypeMapping[hNode.overrideDataType].JavaScript;
    }
    return outputType;
}

function getDefaultValueForHNode(hNode, errorIfNotFound = true) {
    let defaultValue, found;

    let hNodeType = hNode.hNodeType;
    Object.keys(dataTypeMapping).forEach(key => {
        if (dataTypeMapping[key].hNodeTypes && dataTypeMapping[key].hNodeTypes.includes(hNodeType)) {
            defaultValue = dataTypeMapping[key].defaultValue;
            found = true;
            return;
        } else if (dataTypeMapping[key].formats) {
            Object.values(dataTypeMapping[key].formats).forEach(f => {
                if (f.hNodeTypes.includes(hNodeType)) {
                    if (typeof f.defaultValue !== 'undefined') {
                        defaultValue = f.defaultValue;
                    } else {
                        defaultValue = dataTypeMapping[key].defaultValue;
                    }
                    found = true;
                    return;
                }
            });
        }
    });
    if (hNodeType === 'InvisibleElement') {
        defaultValue = dataTypeMapping[hNode.overrideDataType].defaultValue;
        found = true;
    }
    if (!found && errorIfNotFound) throw new Error(`${hNodeType} does not have a default value.`);
    return defaultValue;
}

/**
 * Determines if the component should include the time picker based on the format
 * @param {string} format
 * @returns {boolean} Boolean
 */
function shouldShowTimeInput(format) {
    const timeFormatCharacters = [
        'ISO',
        'p',
        'h',
        'H',
        'm',
        's',
        'S',
        'a',
        'b',
        'B',
        'K',
        'k',
        'X',
        'x',
        'O',
        'z',
        't',
        'T'
    ];

    return timeFormatCharacters.some(char => format.includes(char));
}

function getActionsAllowed(namespace, relation) {
    let actions = [];
    if ((namespace == null || namespace === '') && (relation == null || relation === '')) {
        actions.push(...actionElementActionsByNsRel.dataOperationVerbs);
    } else if (namespace != null && namespace !== '' && (relation == null || relation == '')) {
        const keys = Object.keys(actionElementActionsByNsRel[namespace] ?? {});
        for (let i = 0; i < keys.length; i++) {
            actions.push(...(actionElementActionsByNsRel[namespace]?.[keys[i]] ?? []));
        }
    } else {
        actions.push(...get(actionElementActionsByNsRel, [namespace, relation], []));
        // If we have the namespace and relation, but no actions, then this is
        // probably a ns/rel that needs the dataOperationVerbs
        if (actions.length === 0) {
            actions.push(...actionElementActionsByNsRel.dataOperationVerbs);
        }
    }
    if (actions.length === 0) {
        actions.push(['None', 'none']);
    }
    return actions;
}
